import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { cn } from '../../lib/utils'
import { getPopupGraphic, getPopupLabel, getPopupVisualSeverity } from './popupGraphics'

const FullPagePopupLayout = ({
  isOpen,
  onClose,
  severity = 'notice',
  title,
  message,
  children,
  actions,
  bodyClassName,
  actionsClassName,
  contentClassName,
  disableDismiss = false,
}) => {
  const visualSeverity = getPopupVisualSeverity(severity)
  const graphic = getPopupGraphic(severity)
  const label = getPopupLabel(severity)

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && !disableDismiss && onClose?.()}>
      <DialogContent
        data-severity={visualSeverity}
        mobileFullscreen
        onEscapeKeyDown={(event) => {
          if (disableDismiss) event.preventDefault()
        }}
        className={cn(
          'fabits-global-popup fabits-global-popup-full z-[10001] p-0',
          contentClassName,
        )}
      >
        <DialogHeader className='contents'>
          <div className='fabits-global-popup-hero'>
            <div className='fabits-global-popup-graphic-shell'>
              <img
                className='fabits-global-popup-graphic'
                src={graphic}
                alt=''
                aria-hidden='true'
              />
            </div>
            <p className='fabits-global-popup-eyebrow'>{label}</p>
            <DialogTitle className='fabits-global-popup-title'>{title}</DialogTitle>
          </div>
          {message && (
            <DialogDescription className='fabits-global-popup-description'>
              {message}
            </DialogDescription>
          )}
        </DialogHeader>

        {children && (
          <div className={cn('fabits-global-popup-body', bodyClassName)}>{children}</div>
        )}

        {actions && (
          <DialogFooter className={cn('fabits-global-popup-actions', actionsClassName)}>
            {actions}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default FullPagePopupLayout
